module.exports = __webpack_public_path__ + "media/images/emblems/Onex-coat_of_arms-c4c0ce98d63ed4efa21036179d97c89a.svg";